import React from 'react';
import { LISTING_DEALER } from '../carInventoryTypes';

interface Props {
  compact?: boolean;
  /** AutoTrader-style city pin, used on the vehicle detail panel. */
  showLocationPin?: boolean;
}

/** Selling dealer, shown on the vehicle details page — not on every listing card. */
export const CarDealerDisclosure: React.FC<Props> = ({
  compact = false,
  showLocationPin = false,
}) => (
  <div className={`car-dealer${compact ? ' car-dealer--compact' : ''}`}>
    {showLocationPin && (
      <p className="car-listing-location">
        <i className="ti ti-map-pin" aria-hidden />
        {LISTING_DEALER.city}
      </p>
    )}
    <p className="car-dealer-name">
      Listed by <strong>{LISTING_DEALER.name}</strong>
      <span className="car-dealer-city"> · {LISTING_DEALER.city}</span>
    </p>
  </div>
);
